export const APP_VERSION = '2.5.2';
